import React from 'react'
import { trackAdvertisementClick } from '../tracking'

const AdvertisementLinkWrapper = ({children, item, refElemViewport, eventOrigin = false, className = "custom-placement-item-container"}) => {
    const { link } = item

    if(link  && link.url && eventOrigin) {
        const { pk, title } = item
        const { destinationType , pathType, url} = link

        return (
            <a 
                className={className + ' cursor-pointer'}
                href={url}
                onClick={() => trackAdvertisementClick(eventOrigin, pk, title, url)}
                target={'external' === destinationType ? '_blank'  : '_self'}
                ref={refElemViewport}
                // {...(refElemViewport && {ref: refElemViewport})}
            >
                {children}
            </a>
        )
    } else {
        return (
            <div 
                className={className}
                ref={refElemViewport}
                // {...(refElemViewport && {ref: refElemViewport})}
            >
                {children}
            </div>
        )
    }
}

export default AdvertisementLinkWrapper